import { Injectable, inject, computed, Signal } from '@angular/core';
import { AuthService } from '../api/auth.service';
import { PermissionScope } from '../../interfaces/api/permission.interface';
import { PermissionCode } from '../../constants/permission-codes.constants';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private auth = inject(AuthService);

  private signalCache = new Map<PermissionCode, Signal<boolean>>();

  can(code: PermissionCode): boolean {
    const role = this.auth.user$()?.role;
    if (!role) return false;
    if (role.key === 'administrador') return true;
    return role.permissions.some(
      (permission) => permission.permissionCode === code,
    );
  }

  canSignal(code: PermissionCode): Signal<boolean> {
    const cached = this.signalCache.get(code);
    if (cached) return cached;

    const flag = computed(() => this.can(code));
    this.signalCache.set(code, flag);
    return flag;
  }

  canAnySignal(codes: PermissionCode[]): Signal<boolean> {
    const flags = codes.map((code) => this.canSignal(code));
    return computed(() => flags.some((flag) => flag()));
  }

  scopeOf(moduleKey: string): PermissionScope | undefined {
    const role = this.auth.user$()?.role;
    if (!role) return undefined;
    if (role.key === 'administrador') return 'all';
    return role.scopes[moduleKey];
  }
}
